import React, { useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Hidden,
} from "@material-ui/core";
import AccountSelect from "../../../../components/controls/accounts-select";
import SelectTypesFilter from "./accountingRPT-typeFilter";
import { docTypes, sortTypes } from "./accountingRPT-services";
import { useTranslation } from "react-i18next";
import {
  useStylesUp, useStylesTF, useStylesLbl, useStylesAutoBlack,
} from '../../../../St/Reports/UseStyle';
import SelectTypesSearchFilter from "./accountingTypeSearchFilter";
import TreeSelect, { SHOW_PARENT } from "rc-tree-select";
import deepRenameKeys from "deep-rename-keys";
import AccountTree from "../../../../components/AccountsTreee";
import AccountTreeSelected from "../../../../components/AccountTreeSelected";

export function getLeafAccounts(data) {
  var res = [];
  for (let account of data) {
    if (account.hasOwnProperty("children")) {
      var res1 = getLeafAccounts(account.children);
      res.push(...res1);
    } else {
      if (account.node?.props?.Type == 2) {
        res.push(account.node.props?.value.toString());
      }
    }
  }
  return res;
}

export default function AccountingRPTConForm(props) {
  const { t } = useTranslation(["forms"]);

  const {
    rptParams,
    setRptParams,
    onChangeData,
    AutoOptions,
    onChangeAutoData,
    accounts,
    setAccountsName,
    accountsName,
    typePrint
  } = props;
  const clasup = useStylesUp();
  const claslbl = useStylesLbl();
  const clasAo = useStylesAutoBlack();
  const clasTF = useStylesTF();
  const [value, setValue] = useState([]);
  const onSelect = (selectedKeys, info) => { };
  const mData = deepRenameKeys(accounts, (key) => {
    if (key === "Code") return "value";
  });
  const onChange = (value, ...rest) => {
    console.log(
      "the values",
      getLeafAccounts(rest[1].allCheckedNodes).toString(),
    );
    setValue(value);
    setRptParams({
      ...rptParams,
      accountMlti: getLeafAccounts(rest[1].allCheckedNodes).toString(),
    });
    setAccountsName({
      accountsName,
      name: rest[1],
    });
  };
  return (
    <React.Fragment>
      <Grid container style={{ padding: 5 }} spacing={1}>
        <Grid item lg={12} md={12} sm={12} sx={12}>
          <SelectTypesSearchFilter {...{ rptParams, setRptParams }} />
        </Grid>
        {rptParams?.selectTypeSearch?.id == 2 ?
          (
            <>
              <Hidden only={"xs"}>
                {/* <Grid item lg={4} md={5} sm={7} xs={12}>
                  <FormControl>
                    <TreeSelect
                      style={{
                        minWidth: 450,
                        height: 40,
                        direction: "ltr",
                        fontWeight: "bold",
                        textAlign: "center",
                        color: "black",
                      }}
                      dropdownStyle={{
                        direction: "ltr",
                        maxHeight: 200,
                        overflow: "auto",
                        zIndex: 1500,
                      }}
                      className="check-select"
                      transitionName="rc-tree-select-dropdown-slide-up"
                      choiceTransitionName="rc-tree-select-selection__choice-zoom"
                      dropdownPopupAlign={{
                        overflow: { adjustY: 0, adjustX: 0 },
                        offest: [0, 2],
                      }}
                      placeholder="قم بتحديد الحسابات"
                      showCheckedStrategy={SHOW_PARENT}
                      showSearch
                      autoClearSearchValue
                      maxTagTextLength={10}
                      allowClear
                      treeLine
                      treeCheckable
                      maxTagCount={10}
                      value={value}
                      treeData={mData}
                      treeNodeFilterProp="value"
                      onChange={onChange}
                      onSelect={onSelect}
                      maxTagPlaceholder={(valueList) => {
                        return `${valueList.length} rest...`;
                      }}
                    />
                  </FormControl>
                </Grid>  */}
               <Grid item lg={4} md={5} sm={7} xs={12}>
                  <AccountTreeSelected
                    accounts={accounts}
                    value={value}
                    onChange={onChange}
                    SHOW_PARENT={SHOW_PARENT}
                    onSelect={onSelect}
                    // searchValue={searchValue}
                  />
                </Grid>

              </Hidden>
              <Hidden smUp>
                <Grid item lg={4} md={5} sm={7} xs={12}>
                  <FormControl>

                    <TreeSelect
                      style={{
                        minWidth: 300,
                        height: 40,
                        direction: "ltr",
                        fontWeight: "bold",
                        textAlign: "center",
                        color: "black",
                      }}
                      dropdownStyle={{
                        direction: "ltr",
                        maxHeight: 200,
                        overflow: "auto",
                        zIndex: 1500,
                      }}
                      className="check-select"
                      transitionName="rc-tree-select-dropdown-slide-up"
                      choiceTransitionName="rc-tree-select-selection__choice-zoom"
                      dropdownPopupAlign={{
                        overflow: { adjustY: 0, adjustX: 0 },
                        offest: [0, 2],
                      }}
                      placeholder="قم بتحديد الحسابات"
                      showCheckedStrategy={SHOW_PARENT}
                      showSearch
                      autoClearSearchValue
                      maxTagTextLength={10}
                      allowClear
                      treeLine
                      treeCheckable
                      maxTagCount={10}
                      value={value}
                      treeData={mData}
                      treeNodeFilterProp="value"
                      onChange={onChange}
                      onSelect={onSelect}
                      maxTagPlaceholder={(valueList) => {
                        return `${valueList.length} rest...`;
                      }}
                    />
                  </FormControl>
                </Grid>
              </Hidden>

            </>
          ) :
          (
            <Grid item lg={4} md={6} sm={10} xs={12}>
              <AccountSelect
                accounts={AutoOptions.Accindex}
                account={rptParams.account}
                onSelect={(newValue) => {
                  onChangeAutoData("account", newValue);
                }}
              />
            </Grid>
          )
        }


        <Grid item lg={2} md={2} sm={2} xs={6}>
          <Autocomplete
            classes={clasAo}
            value={rptParams.branch}
            onChange={(event, newValue) => {
              onChangeAutoData("branch", newValue);
            }}
            id="combo-box-demo"
            size="small"
            options={AutoOptions.Branches}
            //getOptionLabel={(option) => option.name}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            style={{}}
            disableClearable
            renderInput={(params) => (
              <TextField
                {...params}
                InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                label={t("branch")}
                variant="outlined"
              />
            )}
          />
        </Grid>
        <Grid item lg={2} md={2} sm={2} xs={6}>
          <Autocomplete
            classes={clasAo}
            value={rptParams.center}
            onChange={(event, newValue) => {
              onChangeAutoData("center", newValue);
            }}
            id="combo-box-demo"
            size="small"
            options={AutoOptions.center}
            //getOptionLabel={(option) => option.name}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            style={{}}
            disableClearable
            renderInput={(params) => (
              <TextField
                {...params}
                InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                label={t("center")}
                variant="outlined"
              />
            )}
          />
        </Grid>
        <Grid item lg={2} md={2} sm={2} xs={6}>
          <TextField
            fullWidth
            className={clasTF.rootCust}
            InputProps={{ className: claslbl.clrBlackTxt }}
            InputLabelProps={{ className: claslbl.clrBlackLblS }}
            variant="outlined"
            size="small"
            id="datef"
            label={t("date-from")}
            type="date"
            format="YYYY-MM-DD"
            name="datef"
            value={rptParams.dateFrom}
            onChange={onChangeData("dateFrom")}
          />
        </Grid>

        <Grid item lg={2} md={2} sm={2} xs={6}>
          <TextField
            fullWidth
            className={clasTF.rootCust}
            InputProps={{ className: claslbl.clrBlackTxt }}
            InputLabelProps={{ className: claslbl.clrBlackLblS }}
            variant="outlined"
            size="small"
            id="dateT"
            label={t("date-to")}
            type="date"
            format="YYYY-MM-DD"
            name="datet"
            value={rptParams.dateTo}
            onChange={onChangeData("dateTo")}
          />
        </Grid>

        <Grid item lg={2} md={2} sm={2} xs={6}>
          <Autocomplete
            classes={clasAo}
            value={rptParams.orderType}
            onChange={(event, newValue) => {
              onChangeAutoData("orderType", newValue);
            }}
            id="combo-box-demo"
            size="small"
            options={sortTypes}
            //getOptionLabel={(option) => option.name}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            style={{}}
            disableClearable
            renderInput={(params) => (
              <TextField
                {...params}
                InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                label={t("order-by")}
                variant="outlined"
              />
            )}
          />
        </Grid>
        <Grid item lg={2} md={2} sm={2} xs={6}>
          <Autocomplete
            classes={clasAo}
            value={rptParams.docType}
            onChange={(event, newValue) => {
              onChangeAutoData("docType", newValue);
            }}
            id="combo-box-demo"
            size="small"
            options={docTypes}
            //getOptionLabel={(option) => option.name}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            style={{}}
            disableClearable
            renderInput={(params) => (
              <TextField
                {...params}
                InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                label={t("doc-type")}
                variant="outlined"
              />
            )}
          />
        </Grid>
        <Grid item lg={1} md={2} sm={2} xs={6}>
          <Autocomplete
            classes={clasAo}
            value={rptParams.omla}
            onChange={(event, newValue) => {
              onChangeAutoData("omla", newValue);
            }}
            id="combo-box-demo"
            size="small"
            options={AutoOptions?.Omlat}
            //getOptionLabel={(option) => option.name}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            style={{}}
            disableClearable
            renderInput={(params) => (
              <TextField
                {...params}
                InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                label={t("omla")}
                variant="outlined"
              />
            )}
          />
        </Grid>
        {rptParams?.selectTypeSearch?.id == 1 && (
          <Grid item lg={2} md={2} sm={2} xs={6}>
            <Autocomplete
              classes={clasAo}
              value={rptParams.typePrint}
              onChange={(event, newValue) => {
                onChangeAutoData("typePrint", newValue);
              }}
              id="combo-box-demo"
              size="small"
              options={typePrint}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.label
              }
              style={{}}
              disableClearable
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                  label={"type print"}
                  variant="outlined"
                />
              )}
            />
          </Grid>
        )}

        <Grid item lg={2} md={4} sm={6} sx={12}>
          <SelectTypesFilter {...{ rptParams, setRptParams }} />
        </Grid>
        <Grid item lg={1} md={2} sm={2} xs={6}>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  fullWidth
                  checked={rptParams.openBalance}
                  onChange={(e) =>
                    onChangeAutoData("openBalance", e.target.checked)
                  }
                  name="chkVat"
                />
              }
              size="small"
              color="primary"
              fontSize="small"
              label={t("initial-balance")}
            />
          </FormGroup>
        </Grid>
        <Grid item lg={1} md={2} sm={2} xs={6}>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  fullWidth
                  checked={rptParams.oldBalance}
                  onChange={(e) =>
                    onChangeAutoData("oldBalance", e.target.checked)
                  }
                  name="chkVat"
                />
              }
              size="small"
              color="primary"
              fontSize="small"
              label={t("prev-balance")}
            />
          </FormGroup>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
